import { Navigate, Route, Routes } from 'react-router-dom'
import { AppLayout } from '@/components/app-layout'
import { RequireSession } from '@/features/auth/require-session'
import { BriefingPage } from '@/pages/briefing-page'
import { BriefingsPage } from '@/pages/briefings-page'
import { ChecklistsPage } from '@/pages/checklists-page'
import { DashboardPage } from '@/pages/dashboard-page'
import { EnrolmentPage } from '@/pages/enrolment-page'
import { HandoverEditorPage } from '@/pages/handover-editor-page'
import { HandoversPage } from '@/pages/handovers-page'
import { ImageAiPage } from '@/pages/image-ai-page'
import { LoginPage } from '@/pages/login-page'
import { NotFoundPage } from '@/pages/not-found-page'
import { ResetPasswordPage } from '@/pages/reset-password-page'
import { SettingsPage } from '@/pages/settings-page'
import { SystemPage } from '@/pages/system-page'

export function App() {
  return (
    <Routes>
      {/* The only routes outside the session — everything else is wrapped. */}
      <Route path="/anmelden" element={<LoginPage />} />
      <Route path="/registrierung/:token" element={<EnrolmentPage />} />
      <Route path="/passwort-zuruecksetzen/:token" element={<ResetPasswordPage />} />

      <Route
        element={
          <RequireSession>
            <AppLayout />
          </RequireSession>
        }
      >
        <Route index element={<Navigate to="/checklists" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/checklists" element={<ChecklistsPage />} />
        <Route path="/protokolle" element={<HandoversPage />} />
        <Route path="/protokolle/:id" element={<HandoverEditorPage />} />
        <Route path="/briefings" element={<BriefingsPage />} />
        <Route path="/briefings/:id" element={<BriefingPage />} />
        <Route path="/bild-ki" element={<ImageAiPage />} />
        <Route path="/system" element={<SystemPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
